// extracted by mini-css-extract-plugin
export var marginNegative = "_6w-5 _6w-3 _6w-1";
export var marginPositive = "_6w-4 _6w-3 _6w-1";
export var modalContent = "_6w-6";
export var samplesTable = "_6w-8";
export var samplesTableContainer = "_6w-7";
export var statBox = "_6w-a";
export var tableCell = "_6w-1";
export var tableCellCenter = "_6w-2 _6w-1";
export var tableCellRight = "_6w-3 _6w-1";
export var tableHeader = "_6w-0";
export var trackingNumber = "_6w-9";